import { RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { MaximoDocType } from "~/utils/maximo-sync";
import { Button, Card, Switch, Text, Title } from "~/components/ui";

type MaximoSyncAllCardProps = {
  withVision: boolean;
  onWithVisionChange: (value: boolean) => void;
  syncingType: MaximoDocType | "all" | null;
  onSyncAll: () => void;
};

export function MaximoSyncAllCard({ withVision, onWithVisionChange, syncingType, onSyncAll }: MaximoSyncAllCardProps) {
  const { t } = useTranslation("admin");

  return (
    <Card size="small" className="bg-noa-hover">
      <div className="flex items-center justify-between gap-4">
        <div className="flex-1">
          <Title level={5} className="!mb-1">
            {t("uploadAdmin.sync.maximo.syncAll")}
          </Title>
          <Text tone="muted">{t("uploadAdmin.sync.maximo.syncAllDescription")}</Text>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex flex-col items-end gap-1">
            <div className="flex items-center gap-2">
              <Text className="text-xs">{t("uploadAdmin.form.withVision")}</Text>
              <Switch
                size="small"
                checked={withVision}
                onChange={onWithVisionChange}
                aria-label={t("uploadAdmin.form.withVision")}
              />
            </div>
            {!withVision && (
              <Text className="text-xs text-orange-600 text-right max-w-48">
                ⚠️ {t("uploadAdmin.sync.maximo.visionWarning")}
              </Text>
            )}
          </div>
          <Button
            variant="primary"
            size="large"
            icon={<RefreshCw size={14} className={syncingType === "all" ? "animate-spin" : undefined} />}
            loading={syncingType === "all"}
            onClick={onSyncAll}
            data-testid="maximo-sync-all-button"
          >
            {t("uploadAdmin.sync.maximo.startSyncAll")}
          </Button>
        </div>
      </div>
    </Card>
  );
}
